import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	emptyState: {
		display: 'flex',
		justifyContent: 'center',
		borderWidth: token('border.width'),
		borderStyle: 'dashed',
		borderColor: token('color.border'),
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
	},
	textBox: {
		marginTop: token('space.0'),
	},
});

export const EmptyState = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Box xcss={styles.emptyState} testId="field-input-attachment-view-empty">
			<Box xcss={styles.textBox}>
				<Text as="p" color="color.text.subtlest" weight="semibold" align="center">
					{intl.formatMessage(messages.emptyStateMessage)}
				</Text>
			</Box>
		</Box>
	);
};
